"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _get = _interopRequireDefault(require("lodash/get"));

var _elementInteraction = _interopRequireDefault(require("./element-interaction"));

/**
 *
 * This is a `smart` component. It will pass along an impression info for an
 * impression of the same ID, if it has been fired
 *
 */
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
var _default = (0, _reactRedux.connect)(function (state, ownProps) {
  return {
    impressionId: (0, _get.default)(state, "impressions[".concat(ownProps.id, "].elementImpressionHeader.impressionId"))
  };
})(_elementInteraction.default);

exports.default = _default;